// NoNearbyBranchBadge - Shown on search cards for masters that are only
// carried by suppliers whose branches are all out of range of the user's
// postcode. Same shape/size as the other stock badges so it swaps in place
// without layout shift. Distinct amber tone signals "reachability", not stock.

export interface NoNearbyBranchBadgeProps {
  className?: string
}

export function NoNearbyBranchBadge({ className = '' }: NoNearbyBranchBadgeProps) {
  return (
    <span
      className={`inline-block whitespace-nowrap text-[11px] bg-amber-50 text-amber-700 px-2 py-0.5 rounded-md font-medium ${className}`}
    >
      NO NEARBY BRANCH
    </span>
  )
}
